import { useDispatch, useSelector } from "react-redux";
import {
  selectDisableProgressBar,
  setDisableProgressBar,
} from "../../app/slices/TrainingSlice";
import PiSwitch from "../../components/PiSwitch";

export default function ProjectSettingsBody() {
  const dispatch = useDispatch();
  const disableProgressBar = useSelector(selectDisableProgressBar);

  return (
    <div className="flex flex-col gap-y-[10px]">
      <PiSwitch
        label="Disable progress bar"
        labelLocId="project_settings.disable_progress_bar.label"
        tooltipLocId="project_settings.disable_progress_bar.tooltip"
        checked={disableProgressBar}
        onChange={(value) => dispatch(setDisableProgressBar(value))}
      />
    </div>
  );
}
